import { TextField } from '@mui/material';
import React from 'react';

export interface FundDetailsCloseDateFieldProps {
  value: string | null;
  error?: string;
  onChange: (isoValue: string) => void;
}

// Shows a plain "YYYY-MM-DD" text field at rest, swapping to a native date
// picker only while focused, so the field reads consistently across browsers
// when not in use.
export const FundDetailsCloseDateField: React.FC<FundDetailsCloseDateFieldProps> = ({
  value,
  error,
  onChange,
}) => (
  <TextField
    placeholder="YYYY-MM-DD"
    onFocus={(e) => {
      (e.target as any).type = 'date';
    }}
    onBlur={(e) => {
      (e.target as any).type = 'text';
    }}
    label="Close Date"
    type="text"
    value={value?.substring(0, 10) || ''}
    onChange={(e) => {
      const val = e.target.value;
      onChange(val ? new Date(val).toISOString() : '');
    }}
    variant="outlined"
    size="small"
    fullWidth
    error={!!error}
    helperText={error}
    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white' } }}
  />
);
